import { render, staticRenderFns } from "./greenEnterpriseCase.vue?vue&type=template&id=ef4e27d4&scoped=true"
import script from "./greenEnterpriseCase.vue?vue&type=script&lang=js"
export * from "./greenEnterpriseCase.vue?vue&type=script&lang=js"
import style0 from "./greenEnterpriseCase.vue?vue&type=style&index=0&id=ef4e27d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4e27d4",
  null
  
)

export default component.exports